const searchOverlay = {
  init(): void {
    const search = document.querySelector<HTMLElement>('.jsDropdownSearch');
    const overlay = document.querySelector<HTMLElement>('#searchOverlay');

    if (!search || !overlay) return;

    search.addEventListener('click', (event) => {
      event.stopPropagation();
      overlay.classList.add('activeClass');
    });

    document.addEventListener('click', (event) => {
      const target = event.target as Node;

      if (!search.contains(target)) {
        overlay.classList.remove('activeClass');
      }
    });
  },
};

export default searchOverlay;
